import GenericModel from '../generic-model';
import { User } from '../user';
import { EmployeeType } from '../employee-type';
import Address from '../project/address';
import Branch from '../branch/branch';
export default class Employee extends GenericModel {
  types?: EmployeeType[];
  user?: User;
  active?: boolean;
  dateOfBirth?: Date;
  extraInfo?: string;
  address?: Address;
  branch?: Branch;
  numberOfJobs?: Number;

  constructor() {
    super();
    this.types = [];
  }
}
